export const parseFormattedNumber = (value: string | number): number => {
  if (typeof value === "number") return value;
  return Number(value.replace(/\./g, "").replace(",", "."));
};

export const yupNumTransform = (value: unknown, originalValue: unknown): number => {
  if (typeof originalValue === "string" && originalValue !== "") {
    return parseFormattedNumber(originalValue);
  }
  return value as number;
};

export const rupiahFormatter: (
  rp: number | string | undefined | null,
) => string = (rp) => {
  if (rp === undefined || rp === null) {
    return "0";
  }

  let srp = rp.toString().replace(/\./g, "").trim();
  const isNegative = srp[0] === "-";
  if (isNegative) {
    srp = srp.slice(1);
  }
  const out: string[] = [];
  let i = 0;
  for (const ch of srp.split("").reverse()) {
    if (i > 0 && i % 3 === 0 && i < srp.length) {
      out.push(".");
    }
    out.push(ch);
    i += 1;
  }
  return `${isNegative ? "-" : ""}${out.reverse().join("")}`;
};

export const normalizeDriverName = (
  driverName?: string,
  driverId?: string,
  fallback = "Unassigned",
): string => {
  if (
    !driverId ||
    driverId === "00000000-0000-0000-0000-000000000000" ||
    !driverName ||
    driverName === "Unknown Driver"
  ) {
    return fallback;
  }
  return driverName;
};

export const isDriverAssigned = (
  driverId?: string,
  driverName?: string,
): boolean => {
  if (
    !driverId ||
    driverId === "00000000-0000-0000-0000-000000000000" ||
    !driverName ||
    driverName === "Unknown Driver"
  ) {
    return false;
  }
  return true;
};